export default __webpack_public_path__ + "static/media/printo.84b53b0f.jpg";